var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPnPremierIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pn-premier-icon1_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 68 71",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pn-premier-icon1_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fefefe}.pn-premier-icon1_svg__st2,.pn-premier-icon1_svg__st4{fill:none;stroke:#020303;stroke-width:2}.pn-premier-icon1_svg__st4{stroke:#d9d9d9}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon1_svg__Desktop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon1_svg__Estate-Agents:-Featured-1",
    transform: "translate(-686 -449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pn-premier-icon1_svg__Group-31",
    transform: "translate(687 449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Fill-1",
    d: "M38.9 19.4c0 10.7-8.7 19.4-19.4 19.4S0 30.2 0 19.4 8.7 0 19.4 0s19.5 8.7 19.5 19.4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#f7dce3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Fill-3",
    className: "pn-premier-icon1_svg__st1",
    d: "M55.9 12.6c2.9 0 5.1 2.2 5.1 4.9v31.9H5.3V17.5c0-2.8 1.7-4.9 4.6-4.9h46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-5",
    className: "pn-premier-icon1_svg__st2",
    d: "M55.9 12.6c2.9 0 5.1 2.2 5.1 4.9v31.9H5.3V17.5c0-2.8 1.7-4.9 4.6-4.9h46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Fill-7",
    className: "pn-premier-icon1_svg__st1",
    d: "M65.2 49.4H0v1c0 3.7 3 7.4 6.7 7.4h51.9c3.7 0 6.7-3.7 6.7-7.4v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-9",
    className: "pn-premier-icon1_svg__st2",
    d: "M65.2 49.4H0v1c0 3.7 3 7.4 6.7 7.4h51.9c3.7 0 6.7-3.7 6.7-7.4v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-11",
    className: "pn-premier-icon1_svg__st2",
    d: "M28.4 53.6h11.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-13",
    className: "pn-premier-icon1_svg__st2",
    d: "M9.5 46.3V16.8h47.3v29.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Fill-15",
    d: "M64.9 55.7L46.3 42.1v23.1c0 .7.6.9 1.1.4l5.2-5.1 5 8.9c.4.7 1.4.8 2.2.3l2.1-1.3c.8-.5 1.1-1.4.7-2.1l-4.9-8.4h6.4c.9-.2 1.4-1.8.8-2.2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ea4a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-17",
    className: "pn-premier-icon1_svg__st2",
    d: "M64.9 55.7L46.3 42.1v23.1c0 .7.6.9 1.1.4l5.2-5.1 5 8.9c.4.7 1.4.8 2.2.3l2.1-1.3c.8-.5 1.1-1.4.7-2.1l-4.9-8.4h6.4c.9-.2 1.4-1.8.8-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-19",
    className: "pn-premier-icon1_svg__st4",
    d: "M45.2 36.8v-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-21",
    className: "pn-premier-icon1_svg__st4",
    d: "M42.3 37.1l-1.8-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-23",
    className: "pn-premier-icon1_svg__st4",
    d: "M40.2 39.2L37 37.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-25",
    className: "pn-premier-icon1_svg__st4",
    d: "M39.9 42.1h-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-27",
    className: "pn-premier-icon1_svg__st4",
    d: "M48.1 37.1l1.8-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pn-premier-icon1_svg__Stroke-29",
    className: "pn-premier-icon1_svg__st4",
    d: "M40.2 44.9L37 46.8"
  }))))));
}
export default SvgPnPremierIcon1;